module.exports = __webpack_public_path__ + "img/pie-chart-dark.4ca7a068.svg";